"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContributionTypes = void 0;
var ContributionTypes;
(function (ContributionTypes) {
    ContributionTypes["CONTRIBUTION"] = "CONTRIBUTION";
    ContributionTypes["WITHDRAWAL"] = "WITHDRAWAL";
})(ContributionTypes = exports.ContributionTypes || (exports.ContributionTypes = {}));
//# sourceMappingURL=ContributionTypes.js.map